<template>
  <!-- Разделитель — рамка br-t-1px на токене --rim: самый слабый hairline темы. -->
  <footer
    id="footer"
    class="d-flex flex-row flex-wrap gap-regular w-100 h-auto flex-justify-between flex-align-center
           pd-4r pd-l-2r pd-r-2r tablet:pd-2r mobile:pd-2r
           bg-canvas br-t-1px br-rim"
  >
    <span class="d-flex flex-align-center gap-regular">
      <p>
        {{ $t('footer.copyright') }}. {{ $t('footer.withLove') }} <svg class="w-regular h-regular t-accent" viewBox="0 0 24 24" fill="currentColor"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg> {{ $t('footer.fromDigitalRealm') }} <a class="d-inline" :href="$t('footer.ozdaoLink')" target="_blank">{{ $t('footer.ozdao') }}</a>
      </p>

      <!-- Переключатель темы. Живёт внутри строки копирайта, а не отдельным
           элементом футера: у футера justify-between на двух детях, третий
           разъехал бы копирайт и соцкнопки по краям. -->
      <button
        type="button"
        class="button button--s ws-nowrap"
        :aria-label="$t('footer.switchTheme')"
        @click="ds.theme.toggle()"
      >
        {{ ds.theme.mode === 'dark' ? $t('footer.themeLight') : $t('footer.themeDark') }}
      </button>
    </span>

    <div class="pos-relative d-flex gap-regular h-2.25r">
      <!-- Плитка отдельным элементом от ссылки: тема задаёт `a { width: max-content }`,
           и ссылка сама размер плитки не удержит. -->
      <div
        v-for="social in socials"
        :key="social.alt"
        class="pos-relative d-inline-block w-2.25r h-2.25r opacity-30 hover:opacity-100 ease-quint-out-400 cursor-pointer"
      >
        <a :href="social.href" target="_blank" class="d-block w-100 h-100">
          <img class="w-100 h-100 theme-invert" :src="social.src" :alt="social.alt"/>
        </a>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ds } from '@ozdao/martyrs/src/design-system/index.js'

// Белые растровые SVG: цвет из них не достать, теме их отдаёт .theme-invert.
const socials = [
  { alt: 'Facebook', href: 'https://www.facebook.com/Ozeransky/', src: '/images/icons/social-fb.svg' },
  { alt: 'Behance', href: 'https://www.behance.net/ozinteractive', src: '/images/icons/social-be.svg' },
  { alt: 'LinkedIn', href: 'https://www.linkedin.com/company/oz-interactive', src: '/images/icons/social-in.svg' },
]
</script>
